import { combineReducers } from 'core/redux'

import { createEntityReducer } from 'util/reducers'

export default combineReducers({
  byId: createEntityReducer('customerRatingSetting'),
})
